var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","align":"center"}},[_c('v-progress-circular',{attrs:{"size":_vm.size,"color":"primary","width":_vm.size / 10,"indeterminate":""}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }